import { Channel, SessionInterface, UserInterface } from "@swivl-mono/types";
import { useRef, useState } from "react";
import { LocalStorageHelper } from "../../../Models/LocalStorage/LocalStorageHelper";
import { UserConversationsInterface } from "../../../Models/Users/Users.Model";
import { MultiChannelColumnFooter } from "./ChatFooter/MultiChannelColumnFooter";
import { MultiChannelChatSection } from "./MultiChannelChatSection";
import { MultiChannelColumnHeader } from "./MultiChannelColumnHeader";
import { ConversationUserListTabsStateType } from "../ConversationsView";
import { SessionMessageData } from "apps/studio/src/Hooks/useSessionMessageData";

interface BaseMultiChannelColumnProps {
  conversation?: UserConversationsInterface;
  selectedUser?: UserInterface;
  channel: Channel;
  handleMarkSessionAsRead?: (sessionId: number, userId: number) => void;
  session?: SessionInterface;
  sessionMessageData?: { [userId: number]: { [sessionId: number]: SessionMessageData } };
  tabState: ConversationUserListTabsStateType;
}

export function MultiChannelColumn(props: BaseMultiChannelColumnProps) {
  const { conversation, selectedUser, channel, session, tabState, handleMarkSessionAsRead, sessionMessageData } = props;
  const [isQuickRepliesDropdownOpen, setIsQuickRepliesDropdownOpen] = useState(false);
  const [isAutoCompleteEnabled, setIsAutoCompleteEnabled] = useState(LocalStorageHelper.getItem("autoCompleteEnabled") !== "false");
  const chatRef = useRef<any>(null);

  const toggleAutoCompleteEnabled = () => {
    console.log("Toggling autocomplete enabled from", isAutoCompleteEnabled, "to", !isAutoCompleteEnabled);
    const newState = !isAutoCompleteEnabled;
    LocalStorageHelper.setItem("autoCompleteEnabled", newState.toString());
    setIsAutoCompleteEnabled(newState);


  }

  const sendMessage = (message: string) => {
    if (chatRef.current) {
      chatRef.current.messageHandler?.sendTextMessage(message);
    }
  };

  const sendTypingFrame = (typing: boolean) => {
    if (chatRef.current) {
      chatRef.current.messageHandler?.sendTypingFrame(typing);
    }
  };

  const handleToggleQuickRepliesDropdown = (isOpen?: boolean) => {
    setIsQuickRepliesDropdownOpen(prevIsOpenState => isOpen ?? !prevIsOpenState);
  }

  if (!selectedUser) {
    return (
      <div className="flex flex-col size-full bg-inherit">
      </div>
    );
  }

  return (
    <div
      className="flex flex-col size-full bg-inherit"
      key={selectedUser?.id + "multi-channel-column"}
    // onFocusCapture={() => session && handleMarkSessionAsRead(session.id, selectedUser?.id)}
    >
      <MultiChannelColumnHeader
        channel={channel}
        session={session}
        selectedUser={selectedUser}
      // sessionMessageData={sessionMessageData}
      />
      {/* 48px for header -- 160px for footer */}
      <div className="w-full h-[calc(100%-208px)]">
        <MultiChannelChatSection
          user={selectedUser}
          key={`selectedUser-${selectedUser?.id}-channel-${channel}`}
          conversation={conversation}
          channel={channel}
          chatRef={chatRef}
          isAutoCompleteEnabled={isAutoCompleteEnabled}

          isQuickRepliesDropdownOpen={isQuickRepliesDropdownOpen}
        />
        <MultiChannelColumnFooter
          user={selectedUser}
          conversation={conversation}
          isAutoCompleteEnabled={isAutoCompleteEnabled}
          toggleAutoCompleteEnabled={toggleAutoCompleteEnabled}
          channel={channel}
          session={session}
          selectedUserId={selectedUser?.id}
          sendMessage={sendMessage}
          sendTypingFrame={sendTypingFrame}
          isQuickRepliesDropdownOpen={isQuickRepliesDropdownOpen}
          handleToggleQuickRepliesDropdown={handleToggleQuickRepliesDropdown}
        />
      </div>
    </div>
  )
}

